"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _env = require("../env");

var _IGC_JS2Native = require("../IGC_JS2Native");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var httpRequest = {
  /**
   * 设置基本配置
   * @param {Object} options 配置项
   * @options {Function} options.init 初始化函数，会将内部依赖的 axios 透传出去，已便设置全局性的属性
   * @returns {httpRequest}
   */
  config: function config(options) {
    var init = options.init;

    if (typeof init === 'function') {
      init.apply(this, [{
        axios: _axios["default"]
      }]);
    }

    return this;
  },

  /**
   * 兼容 App 内及原生 ajax 请求
   * @param {string} url 请求地址
   * @param {Object=} params 请求参数
   * @param {Object=} options 配置项
   * @param {string} options.method 请求方法
   * @param {boolean=false} options.forceAjax 强制 ajax 请求，不走 App 原生
   * @param {string} options.outUrl 外部域名API请求
   * @returns {Promise}
   */
  request: function request(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$method = options.method,
        method = _options$method === void 0 ? 'get' : _options$method,
        _options$headers = options.headers,
        headers = _options$headers === void 0 ? {} : _options$headers;

    if (_env.env.isApp && !options.forceAjax) {
      // 通过原生调用 url 时，要去掉开头的 '/'，因为客户端会拼接 '/'
      url = url.indexOf('/') === 0 ? url.substr(1) : url;
      return new Promise(function (resolve) {
        (0, _IGC_JS2Native.JS2Native)({
          name: 'doRequest',
          params: {
            url: url,
            method: method,
            data: params,
            headers: headers // 安卓没实现 headers 的处理，所以这里暂时没意义

          }
        }).then(function (_ref) {
          var data = _ref.data;
          resolve(data);
        });
      });
    } else {
      if (method.toLowerCase() !== 'get') {
        options.data = params;
        params = {};
      } // TODO:本地调试
      // 通过 js 调用 url 时，需要加上开头的 /
      // let instance = axios.create({
      //   baseURL: '',
      //   timeout: 15000
      // })
      // return instance.request({
      //   url,
      //   params,
      //   ...options
      // }).then(response => {
      //   return response.data;
      // });
      // TODO:线上用
      // // 通过 js 调用 url 时，需要加上开头的 /


      url = url.indexOf('/') === 0 ? url : '/' + url; // 更改API请求链接，外部传什么访问什么

      if (options.outUrl) {
        url = options.outUrl;
      }

      return _axios["default"].request(_objectSpread({
        url: url,
        params: params
      }, options)).then(function (response) {
        return response.data;
      });
    }
  },
  get: function get(url, params, options) {
    return this.request(url, params, options);
  },
  post: function post(url, params, options) {
    return this.request(url, params, _objectSpread(_objectSpread({}, options), {}, {
      method: 'post'
    }));
  }
};
var _default = httpRequest;
exports["default"] = _default;